import { apiSlice } from "../../app/api/apiSlice";
export const authApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
//        baseQuery: fetchBaseQuery({ baseUrl: process.env.REACT_APP_CUSTOMER_BASE_URL }),
            login: builder.mutation({
                query: credentials => ({
                        url: '/account/login/',
                        method: 'POST',
                        body: {...credentials}
                    })
            }),
        })
})



export const {
    useLoginMutation
} = authApiSlice